import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './PaymentStatus.css';

const Cancel = () => {
    const history = useHistory();

    useEffect(() => {
        const timer = setTimeout(() => {
            history.push('/subscription');  // or wherever you want
        }, 5000);

        return () => clearTimeout(timer);
    }, [history]);

    return (
        <div className="status-container cancel">
            <h1>Payment Canceled ❌</h1>
            <p>Your payment was not completed. Please try again.</p>
            <p>Redirecting to pricing page...</p>
        </div>
    );
};

export default Cancel;
